module.exports = __webpack_public_path__ + "static/media/rastar.2fa349f7.png";